export default function ShowDoneIconOnSelect() {
    return (
        <div style={checkMarkStyle}>
            <svg
                viewBox="0 0 24 24"
                width="36"
                height="36"
                stroke="white"
                strokeWidth="2"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
        </div>
    );
}

const checkMarkStyle = {
    position: 'absolute',
    top: '-17px',
    right: '-17px',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    transform: 'scale(0.5)',
    backgroundColor: 'var(--secondary-color)',
    transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
};
